import {
  SEND_MESSAGE_START,
  SEND_MESSAGE_SUCCESS,
  SEND_MESSAGE_ERROR,
} from '../../constants';
import { updateReservation } from '../Reservation/updateReservation';
import { setLoaderStart, setLoaderComplete } from '../loader/loader';
import showToaster from '../../helpers/showToaster';
import { ThreadItemsQuery, sendMessage as mutation  } from '../../lib/graphql';

export function sendMessageAction(
  threadId,
  threadType,
  content,
  type,
  startDate,
  endDate,
  personCapacity,
  reservationId,
  receiverName,
  senderName,
  receiverType,
  receiverEmail,
  currentPage,
  searchKey,
  listIdKey,
  startDateFilter,
  endDateFilter,
  orderBy,
  dateFilter
) {
  return async (dispatch, getState, { client }) => {

    try {
      dispatch({
        type: SEND_MESSAGE_START,
      });
      dispatch(setLoaderStart('hostAction'));

      // Send Message
      const { data } = await client.mutate({
        mutation,
        variables: {
          threadId,
          content,
          type,
          startDate,
          endDate,
          personCapacity,
          reservationId
        },
        refetchQueries: [
          {
            query: ThreadItemsQuery,
            variables: {
              threadId,
              threadType
            },
          }
        ]
      });

      if (data?.sendMessage?.status == 'alreadyPerformed') {
        showToaster({ messageId: 'sendMessageError1', toasterType: 'error' })
        dispatch({
          type: SEND_MESSAGE_ERROR,
        });
      } else if (data?.sendMessage?.status == 'approvedForThisDates') {
        showToaster({ messageId: 'sendMessageError2', toasterType: 'error' })
        dispatch({
          type: SEND_MESSAGE_ERROR,
        });
      } else if (data?.sendMessage?.status != 'userbanned') {
        if (reservationId != null && reservationId != undefined) {
          dispatch(updateReservation(reservationId, type, threadType, threadId, currentPage, searchKey, listIdKey,
            startDateFilter,
            endDateFilter,
            orderBy,
            dateFilter));
        }
        dispatch({
          type: SEND_MESSAGE_SUCCESS,
        });
      }
      dispatch(setLoaderComplete('hostAction'));

    } catch (error) {
      dispatch({
        type: SEND_MESSAGE_ERROR,
        payload: {
          error
        }
      });
      dispatch(setLoaderComplete('hostAction'));

      return false;
    }
    return true;
  };
}